import { Fragment } from 'react';

import { observer } from 'mobx-react-lite';
import Separator from 'shared/layout/Separator';
import Spacer from 'shared/layout/Spacer';

import Question from './Question';

export default observer(({ form }) => {
  const {
    questions: { sections = [] },
  } = form;

  return sections.map((s, idx) => {
    const visibleQuestions = s.questions.filter((question) => !question.hidden);
    if (visibleQuestions.length === 0) return null;

    return (
      <Fragment key={idx}>
        <Spacer top={16} bottom={16}>
          <Separator />
        </Spacer>
        {visibleQuestions.map((question) => (
          <Question question={question} key={question.id} disabled={form.disabled} />
        ))}
      </Fragment>
    );
  });
});
